import i18n from 'src/i18n';
const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'farm_name',
            label: i18n.t('common_words.farm'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'business_name',
            label: i18n.t('common_words.company'),
            align: 'center',
            sortable: true,
        },
    ];
    return { tableColumns };
}
export default configTable;